import List, {ListProps} from '@mui/material/List';
import ListItem, {ListItemProps} from '@mui/material/ListItem';
import ListItemAvatar, {ListItemAvatarProps} from '@mui/material/ListItemAvatar';
import ListItemIcon, {ListItemIconProps} from '@mui/material/ListItemIcon';
import ListSubheader, {ListSubheaderProps} from '@mui/material/ListSubheader';
import ListItemButton, {ListItemButtonProps} from '@mui/material/ListItemButton';
import ListItemSecondaryAction, {ListItemSecondaryActionProps} from '@mui/material/ListItemSecondaryAction';

import {styled} from '@mui/material/styles';
import {ListItemText, ListItemTextProps} from '@mui/material';

export const CList = styled(List)<ListProps>(
  (/* { theme } */) => ({
  }),
);

export const CListItem = styled(ListItem)<ListItemProps>(
  (/* { theme } */) => ({
  }),
);

export const CListItemAvatar = styled(ListItemAvatar)<ListItemAvatarProps>(
  (/* { theme } */) => ({
  }),
);

export const CListItemIcon = styled(ListItemIcon)<ListItemIconProps>(
  (/* { theme } */) => ({
  }),
);

export const CListSubheader = styled(ListSubheader)<ListSubheaderProps>(
  (/* { theme } */) => ({
  }),
);

export const CListItemButton = styled(ListItemButton)<ListItemButtonProps>(
  (/* { theme } */) => ({
  }),
);

export const CListItemSecondaryAction = styled(ListItemSecondaryAction)<ListItemSecondaryActionProps>(
  (/* { theme } */) => ({
  }),
);

export const CListItemText = styled(ListItemText)<ListItemTextProps>(
    (/* { theme } */) => ({
    }),
);
